<template>
  <v-app id="app" data-app>
    <Alert/>
    <Loader />
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import Alert from './components/alert/Alert.vue';
import Loader from './components/loader/Loader.vue';
import { config } from '@/plugins/env.config'
import { changeTheme } from './themes';

import { createNamespacedHelpers } from "vuex";
const generalModule = createNamespacedHelpers("general");

export default {
  name: 'App',
  components: { Alert, Loader },

  mounted(){
    this.setFavicon()
    this.setTheme()
    this.setWebTitle()
  },
  
  created() {
    if (!this.viewConfiguration) {
      this.loadViewConfigurationFromStorage();
    }
  },

  computed: {
    ...mapGetters(['webTitle']),

    tokenExtensions() {
      return this.$store.getters.tokenExtensions;
    }
  },
  watch: {
    tokenExtensions(tokenExtensionsValue) {
      if (tokenExtensionsValue) {
        this.setViewConfiguration();
      }
    }
  },

  methods: {
    ...generalModule.mapActions(['fetchViewConfiguration', 'loadViewConfigurationFromStorage']),

    setFavicon(){
      const favicon = document.getElementById("favicon")
      if(config.theme === 'KONEKSI'){
        favicon.href = process.env.BASE_URL+"koneksi-favicon.ico"
      }
      else{
        favicon.href = process.env.BASE_URL+"favicon.ico"
      }
    },

    setTheme(){
      const tokenExtensions = this.$store.getters.tokenExtensions

      if(tokenExtensions){
        const providerSlug = tokenExtensions.providerSlug

        if(providerSlug){
          changeTheme(providerSlug)
        }
      }
    },

    async setViewConfiguration() {
      const tokenExtensions = this.tokenExtensions;

      if (tokenExtensions) {
        const providerSlug = tokenExtensions.providerSlug;

        if (providerSlug) {
          await this.fetchViewConfiguration(providerSlug);
          await this.loadViewConfigurationFromStorage();
        }
      }
    },

    setWebTitle() {
      if(this.webTitle){
        document.title = this.webTitle
      }
    }
  }
};
</script>
